import React from 'react';
import { AuxWrap } from 'hoc';

import moment from 'moment';
// Common date-time formatter
function dateTimeFormatter(value) {
	if (!value) return <strong>- -</strong>;
	try {
		const date = new Date(value);
		if (isNaN(date.getTime())) return <strong>- -</strong>;
		const locale = window.i18next?.language || 'en';
		const year = date.getFullYear();
		let month = date.toLocaleString(locale, {
			month: 'short',
		});
		month = month.replace('.', '');
		const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1);
		const day = date.getDate().toString().padStart(2, '0');
		const options = { hour: '2-digit', minute: '2-digit', second: '2-digit' };
		const time = date.toLocaleTimeString(locale, options);
		return (
			<AuxWrap>
				<strong>{`${capitalizedMonth} ${day} ${year}, ${time}`}</strong>
			</AuxWrap>
		);
	} catch {
		return <strong>- -</strong>;
	}
}

const tableConfig = [
	{
		dataHead: [
			{ displayText: 'date' },
			{ displayText: 'software_version' },
			{ displayText: 'changes' },
		],
		dataBody: {
			created_at: {
				path: 'created_at',
				view: ({ value }) => value && moment(value).format('MM.DD.YYYY'),
			},
			version: {
				path: ['concentrator_firmware', 'version'],
			},
			description: {
				path: ['concentrator_firmware', 'description'],
				view: ({ value }) => {
					if (value) {
						let arr = JSON.parse(value);
						arr = arr.filter((value) => value !== null);
						let result = arr.join(' ');
						return <AuxWrap>{result}</AuxWrap>;
					}
				},
			},
		},
	},
	{
		dataHead: [
			{ displayText: 'pairing_date' },
			{ displayText: 'unpairing_date' },
			{ displayText: 'device' },
		],
		dataBody: {
			paired_at: {
				path: 'paired_at',
				view: ({ value }) => dateTimeFormatter(value),
			},
			unpaired_at: {
				path: 'unpaired_at',
				view: ({ value }) => dateTimeFormatter(value),
			},
			device_name: {
				path: ['device_name', 'name'],
			},
		},
	},
	{
		dataHead: [
			{ displayText: 'connection_date' },
			{ displayText: 'disconnection_date' },
		],
		dataBody: {
			connected_at: {
				path: 'connected_at',
				view: ({ value }) => dateTimeFormatter(value),
			},
			disconnected_at: {
				path: 'disconnected_at',
				view: ({ value }) => dateTimeFormatter(value),
			},
		},
	},
	{
		dataHead: [
			{ displayText: 'Error Description' },
			{ displayText: 'Error Date & Time' },
		],
		dataBody: {
			description: {
				path: 'description',
			},
			happened_at: {
				path: 'happened_at',
				view: ({ value }) => dateTimeFormatter(value),
			},
		},
	},
];

export default tableConfig;
